export enum DefaultCacheKey {
  SessionContainer = 'SessionContainer',
  DismissedAlerts = 'DismissedAlerts'
}
